import * as main from './main';
import { updateAxisType, updateQueryString, highlightSeason, highlightSelectedRegionInRegionalChart } from '../utils';
import { showRegion, showStation } from '../components/charts/map';

import { plotTimeSeriesSingleModel, cleanTrendSingleModel } from '../components/charts/time-series-single-model';

/*import interfaces and extend window variable*/
import { Aeroval } from '../types/global';
declare var aeroval: Aeroval;

document.addEventListener('DOMContentLoaded', () => {
	if (window.location.pathname.includes('pages/evaluation')) init();
});

function init(): void {
	console.log('initialize evaluation page');
	// set some defaults
	aeroval.goto = false;
	aeroval.tsType = 'regular'; //diurnal cycle
	aeroval.seriesVisibility = {};
	aeroval.menuButtons = ['parameter', 'observation', 'model', 'time', 'statistic'];
	aeroval.axisType = 'linear';

	main.getQueryStrings();
	main.getExperiments();
	main.updateURLs('project', aeroval.project);

	// scattering axis toggle
	const scatAxisToggle = document.getElementById('scat-axis-toggle') as HTMLInputElement;
	if (!scatAxisToggle) return
	scatAxisToggle.addEventListener('change', function () {
		aeroval.axisType = (this.checked) ? 'logarithmic' : 'linear'
		updateAxisType();
	});
}

export function callbackGlobStat(update_ts = true, update_scat = true) {
	document.querySelector('#map')?.classList.remove('loading');
	const initLoader = document.getElementById('init-loader');
	if (initLoader) initLoader.style.display = 'none';
	if (aeroval.tsType == 'regular') {
		main.ts(update_ts, update_scat);
	} else if (aeroval.tsType == 'weekly') {
		main.tsWeekly(update_ts, update_scat);
	}
}

export function callbackMenu(reg_stat = true, update_ts = true, update_scat = true) {
	makeTsTabs();
	main.map(reg_stat, update_ts, update_scat);
}

function makeTsTabs() {
	//if ts div does not exist yet, create ts divs
	const containerTS = document.getElementById('container-ts');
	if (!containerTS) return

	let containerTsContent: string = ''
	if (typeof aeroval.experiment.additional_ts_tabs != 'undefined') {
		//nav
		containerTsContent = `<nav>;
				<div class="nav nav-tabs" id="nav-ts-tab" role="tablist">
				<a class="nav-item nav-link active" id="nav-ts-tab" data-toggle="tab" href="#nav-ts" role="tab" aria-controls="nav-ts" aria-selected="true">Total</a>`
		for (let tab of aeroval.experiment.additional_ts_tabs) {
			containerTsContent +=
				`<a class="nav-item nav-link" id="nav-${tab}-tab" data-toggle="tab" 
					href="#nav-${tab}" role="tab" 
					aria-controls="nav-${tab}" aria-selected="true">
					${tab}</a>`
		}
		containerTsContent += `</div>
				</nav>`;

		//content
		containerTsContent += `<div class="tab-content" id="nav-tabContent">;
				<div id="nav-ts"></div>`;
		for (let tab of aeroval.experiment.additional_ts_tabs) {
			containerTsContent += `<div id="nav-${tab}"></div>`;
		}
		containerTsContent += '</div>';
		const tsInfo = document.getElementById('ts-info');
		if (tsInfo) tsInfo.style.setProperty('margin-top', '40px');
	} else if (!containerTS.innerHTML.startsWith('<div id="evaluation-ts"')) {
		containerTS.innerHTML = '<div id="evaluation-ts"></div>';
	}
	if (containerTsContent) containerTS.innerHTML = containerTsContent
}

export function update(which: string, what: any, wait = false): void {
	console.info('update ', which, 'with ', what);
	if (which == 'station' && what) {
		//for MODIS, station are tuples, and seen hre as array
		aeroval.station = (typeof what != 'string') ? `(${what[0].toFixed(1)}, ${what[1].toFixed(1)})` : what;
		aeroval.region = undefined
		showStation(aeroval.station);
		highlightSelectedRegionInRegionalChart('reg-stat', '');
		if (aeroval.tsType == 'regular') {
			main.ts();
		} else {
			main.tsWeekly();
		}
		updateQueryString(which, what);
		main.updateURLs(which, what);
		updateQueryString('region', '');
		main.updateURLs('region', '');
	}
	if (which == 'region' && what) {
		//for MODIS, station are tuples, and seen hre as array
		aeroval.region = what;
		aeroval.station = undefined;
		showStation('');
		showRegion(what, aeroval.settings.zoomOnSelectedRegion === 'true');
		highlightSelectedRegionInRegionalChart('reg-stat', what);
		//main.plotRegStat(true, true);
		if (aeroval.tsType == 'regular') {
			main.ts();
		} else {
			main.tsWeekly();
		}
		updateQueryString(which, what);
		main.updateURLs(which, what);
		updateQueryString('station', '');
		main.updateURLs('station', '');
	}
	if (which == 'parameter') {
		delete aeroval.chartOptions;
		aeroval.parameter.dir = what;
		main.topMenu();
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'experiment') {
		aeroval.experiment = aeroval.experiments[what];
		aeroval.experiment.name = what;
		delete aeroval.zoom;
		delete aeroval.chartOptions;
		main.getExperiments(true);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'model') {
		aeroval.model.dir = what;
		//get modVar
		aeroval.model.var = aeroval.modVars[what];
		main.map(true, true);
		main.showMenu(which, what, what);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'observation') {
		aeroval.observation = what;
		main.map(true, true);
		main.showMenu(which, what, what);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'statistic') {
		delete aeroval.chartOptions;
		aeroval.statistic = aeroval.statistics[what];
		aeroval.statistic.dir = what;
		main.map(true, false, false);
		if (!aeroval.statistic.dir.includes('trend')) {
			cleanTrendSingleModel('evaluation-ts');
		} else if (aeroval.data.ts) {
			plotTimeSeriesSingleModel(aeroval.data.ts, 'evaluation-ts', true, aeroval.tsType);
		}
		main.showMenu(which, aeroval.statistic.name);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'layer') {
		delete aeroval.chartOptions;
		aeroval.layer = what;
		if (!wait) {
			main.map(true, true);
			main.profile();
			main.showMenu('parameter', aeroval.par.name);
		}
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'frequency') {
		aeroval.frequency = what;
		if (what == 'monthly') {
			aeroval.tsType = 'regular';
		}
		main.checkSeasonMenu();
		main.topMenu();
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'time') {
		aeroval.time = what;
		delete aeroval.dateMin;
		delete aeroval.dateMax;
		main.map(true, true, true);
		main.showMenu(which, what);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'season') {
		aeroval.season = what;
		main.getExtremeDates(false, false);
		if (aeroval.statistic.dir.includes('trend')) {
			main.map(true, true, true);
			//addTrendSingleModel('evaluation-ts');
			if (aeroval.tsType != 'weekly') {
				highlightSeason('evaluation-ts');
			}
		} else if (aeroval.tsType == 'weekly') {
			main.map(true, true, true);
		} else {
			main.map(true, false, true);
			if (aeroval.tsType != 'weekly') {
				highlightSeason('evaluation-ts');
			}
		}
		main.showMenu('time', aeroval.time);
		updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'tsType') {
		aeroval.tsType = what;
		aeroval.granularity = 'season';
		main.topMenu();
		updateQueryString(which, what);
	}
	if (which == 'granularity') {
		aeroval.granularity = what;
		main.tsWeekly();
	}
}
